var __dirname = "/";
// IMPORTS:
var mapData = require(/*! ./map.js */"./map.js");
var UTILS = require(/*! ../libs/utils.js */"../libs/utils.js");
var config = require(/*! ../config.js */"../config.js");
var gClasses = require(/*! ./classes.js */"./classes.js");
var gameVersion = require(/*! ../../version.json */"../../version.json");
var sid = 0;

// VALID CONFIG:
module.exports.validConfig = function (conf) {
  // CHECK MODES:
  if (conf.modes) {
    for (var i = 0; i < conf.modes.length; ++i) {
      if (!mapData.modes[conf.modes[i]]) {
        return "Invalid Mode in Config.";
      }
    }
  }

  // CHECK CLASSES:
  if (conf.classes) {
    for (var i = 0; i < conf.classes.length; ++i) {
      if (!gClasses[conf.classes[i]]) {
        return "Invalid Class in Config.";
      }
    }
  }

  // CHECK SETTINGS:
  if (conf.settings) {
    var tmpC = 0;
    for (var sett in conf.settings) {
      if (conf.settings.hasOwnProperty(sett)) {
        var tmpSe = conf.settings[sett];
        var foundVN = -1;
        for (var i = 0; i < config.serverConfig.length; ++i) {
          if (config.serverConfig[i].varN == sett) {
            foundVN = i;
            break;
          }
        }
        if (foundVN < 0) {
          return "Invalid Setting in Config.";
        } else {
          var tmpO = config.serverConfig[foundVN];
          if (!tmpO.input && !tmpO.bool) {
            if (!UTILS.isNumber(tmpSe)) {
              return "Invalid Config Value.";
            } else {
              if (tmpSe > (tmpO.maxF || tmpO.max) || tmpSe < tmpO.min) {
                return "Config Value out of Range.";
              }
            }
          }
        }
        tmpC++;
        if (tmpC > config.serverConfig.length + 1) {
          return "Settings Mismatch.";
        }
      }
    }
  }

  // ALL GOOD:
  return null;
};

// VALIDATE MAP:
module.exports.validMap = function (tmpMap, featured) {
  // MAP NAME:
  if (!UTILS.isString(tmpMap.name) || !tmpMap.name.replace(/\s/g, '').length) {
    return "Missing map name.";
  } else {
    if (tmpMap.name.indexOf("<") !== -1 || tmpMap.name.indexOf(">") !== -1) {
      return "Illegal characters in map name.";
    } else {
      if (tmpMap.name.length > 16) {
        return "Map name too long.";
      }
    }
  }

  // CHECK SPAWNS:
  if (!UTILS.isArray(tmpMap.spawns) || !tmpMap.spawns.length) {
    return "Missing spawn points.";
  } else {
    if (tmpMap.spawns.length > config.spawnLimit) {
      return "Too many spawn points.";
    } else {
      for (var i = 0; i < tmpMap.spawns.length; ++i) {
        var tmpSpawn = tmpMap.spawns[i];
        if (!UTILS.isArray(tmpSpawn) || !tmpSpawn.length || tmpSpawn.length < 3 || tmpSpawn.length > 5) {
          return "Spawn point error.";
        } else {
          for (var x = 0; x < tmpSpawn.length; ++x) {
            if (x < 3 && !UTILS.isNumber(tmpSpawn[x])) {
              return "Spawn point error.";
            } else {
              if (x == 3 && !(tmpSpawn[x] != undefined || tmpSpawn[x] != 1 || tmpSpawn[x] != 2)) {
                return "Spawn team error.";
              }
            }
          }
        }
      }
    }
  }

  // OBJECTS:
  if (!UTILS.isArray(tmpMap.objects) || !tmpMap.objects.length) {
    return "Missing objects.";
  } else {
    if (tmpMap.objects.length > (featured ? config.objectLimitF : config.objectLimit)) {
      return "Map exceeds object limit.";
    } else {
      for (var i = 0; i < tmpMap.objects.length; ++i) {
        var tmpObj = tmpMap.objects[i];
        if (!UTILS.isArray(tmpObj.s) || tmpObj.s.length != 3 || !UTILS.arrayInts(tmpObj.s)) {
          return "Object scale error.";
        }
        if (!UTILS.isArray(tmpObj.p) || tmpObj.p.length != 3 || !UTILS.arrayInts(tmpObj.p)) {
          return "Object position error.";
        }
        if (UTILS.isArray(tmpObj.r)) {
          if (tmpObj.r.length != 3 || !UTILS.arrayInts(tmpObj.r)) {
            return "Object rotation value error.";
          }
        } else {
          if (tmpObj.r != undefined) {
            return "Object rotation error.";
          }
        }
        if (tmpObj.d != undefined && !UTILS.isNumber(tmpObj.d)) {
          return "Object direction error.";
        }
        tmpObj.col = !!tmpObj.col;
      }
    }
  }

  // ALL GOOD:
  return null;
};

// GAME:
module.exports.obj = function (isCustom, index, DATABASE, RENDER, SOUND, PARTICLES, io, serverManager, serverPort) {
  // IMPORTS:
  this.isCustom = isCustom;
  this.isPrimary = index == 0;
  this.sid = sid++;
  this.gameInstance = null;
  this.connectedClients = 0;
  this.password = undefined;
  this.map = new mapData.manager(RENDER, PARTICLES, UTILS, config);
  this.store = require(/*! ./store.js */"./store.js");
  this.attach = require(/*! ./attach.js */"./attach.js");
  this.weapons = require(/*! ./weapons.js */"./weapons.js");
  this.classes = gClasses;
  this.streaks = require(/*! ./streaks.js */"./streaks.js");
  this.sprays = require(/*! ./sprays.js */"./sprays.js");
  this.projectiles = new (require(/*! ./projectile.js */"./projectile.js"))(this, io);
  this.controls = null;
  this.players = new (require(/*! ./players.js */"./players.js").manager)(this, RENDER, SOUND, PARTICLES, UTILS, config, io);
  this.endData = {
    ed: [],
    vo: null
  };
  this.endTimer = 0;
  this.banList = [];
  this.destObjs = [];
  this.hideWeapon = [false, false, false];
  var context = this;
  var tmpObj;
  var tmpObj2;
  var tmpTimer; // APPLY CONFIG:
  this.applyConfig = function (data, featured, isDev) {
    data = data || {};
    this.config = {};
    for (var i = 0; i < config.serverConfig.length; ++i) {
      var tmpO = config.serverConfig[i];
      if (tmpO.bool) {
        if (data[tmpO.varN] == undefined) {
          this.config[tmpO.varN] = tmpO.def;
        } else {
          this.config[tmpO.varN] = !!data[tmpO.varN];
        }
      } else {
        if (tmpO.input) {
          var tmpD = data[tmpO.varN];
          if (!UTILS.isString(tmpD)) {
            tmpD = tmpO.def;
          }
          this.config[tmpO.varN] = UTILS.sanitizeStr(tmpD);
          if (tmpD.length > 16) {
            tmpD = tmpD.substring(0, 16);
          }
        } else {
          var tmpD = data[tmpO.varN];
          if (!UTILS.isNumber(tmpD)) {
            tmpD = tmpO.def;
          }
          this.config[tmpO.varN] = UTILS.limitMM(tmpD, tmpO.min, featured ? tmpO.maxF || tmpO.max : tmpO.max);
        }
      }
    }

    // MAPS:
    this.config.maps = data.maps;
    if (!UTILS.isArray(this.config.maps) || !this.config.maps.length || this.config.maps.length > this.map.maps.length) {
      this.config.maps = [];
      for (var i = 0; i < this.map.maps.length; i++) {
        this.config.maps.push(i);
      }
    } else {
      for (var i = 0; i < this.config.maps.length; i++) {
        if (!this.map.maps[this.config.maps[i]]) {
          this.config.maps = [0];
          break;
        }
      }
    }

    // MODES:
    this.config.modes = data.modes;
    if (!UTILS.isArray(this.config.modes) || !this.config.modes.length || this.config.modes.length > this.map.modes.length) {
      this.config.modes = null;
    } else {
      for (var i = 0; i < this.config.modes.length; i++) {
        if (!this.map.modes[this.config.modes[i]]) {
          this.config.modes = null;
          break;
        }
      }
    }

    // CLASSES:
    var resetClasses = false;
    this.config.classes = data.classes;
    if (!UTILS.isArray(this.config.classes) || !this.config.classes.length || this.config.classes.length > this.classes.length) {
      resetClasses = true;
    } else {
      for (var i = 0; i < this.config.classes.length; i++) {
        if (!this.classes[this.config.classes[i]]) {
          resetClasses = true;
          break;
        }
      }
    }
    if (resetClasses) {
      this.config.classes = [];
      for (var i = 0; i < this.classes.length; i++) {
        this.config.classes.push(i);
      }
    }
  };
  this.applyConfig();

  // GET INFO:
  this.getInfo = function () {
    return this.mode.alias + "_" + this.map.maps[this.mapIndex].name;
  };

  // REPLACE MAP:
  this.customMap = function (mapData, id, creator, featured, skipCheck) {
    if (mapData) {
      try {
        var tmpMap = JSON.parse(mapData);
        if (io) {
          this.customMapData = {
            data: mapData,
            id: id,
            featured: featured,
            creator: creator
          };
        }
        if (!skipCheck) {
          var tmpErr = module.exports.validMap(tmpMap, featured);
          if (tmpErr) {
            return tmpErr;
          }
        }

        // FINISH:
        for (var x = 0; x < tmpMap.objects.length; ++x) {
          tmpMap.objects[x].i = config.prefabIDS[tmpMap.objects[x].i || tmpMap.objects[x].id || 0];
          if (!tmpMap.objects[x].i) {
            return "Object ID error.";
          }
          tmpMap.objects[x].t = config.textureIDS[tmpMap.objects[x].t || 0];
          if (!tmpMap.objects[x].t) {
            return "Object Texture error.";
          }
        }
        tmpMap.creator = creator;
        this.map.setMaps([tmpMap]);
        this.config.maps = [0];
      } catch (e) {
        return "Map error occured.";
      }
      ;
    }
  };

  // PLAY SOUND:
  this.playSound = function (id, volume, emiter, skip, rate) {
    if (volume) {
      if (SOUND) {
        SOUND.play(id, volume, false, rate);
      } else {
        for (var i = 0; i < this.players.list.length; ++i) {
          tmpObj = this.players.list[i];
          if ((tmpObj.active || tmpObj.spectating) && (emiter != tmpObj || skip)) {
            io.send(tmpObj.id, "s", id, emiter.sid, volume);
          }
        }
      }
    }
  };

  // SOUND FROM PLAYER:
  this.playerSound = function (id, sid, vol, emiter, rate, maxDst) {
    tmpObj = emiter || this.players.findBySid(sid);
    var tmpHowl = Howler.pos();
    if (tmpObj && !(maxDst && maxDst < UTILS.getDistance3D(tmpObj.x, tmpObj.y, tmpObj.z, tmpHowl[0], tmpHowl[1], tmpHowl[2]))) {
      SOUND.play3D(id, tmpObj.x, tmpObj.y, tmpObj.z, vol || 1, rate);
    }
  };

  // MOVE OBJECT AND MESH:
  this.moveObj = function (obj, x, y, z) {
    obj.x = x;
    obj.y = y;
    obj.z = z;
    if (obj.meshRef) {
      obj.meshRef.position.set(x, y, z);
    }
  };

  // EXPLOSION:
  this.explosion = function (x, y, z, s, dmg, owner) {
    for (var i = 0; i < this.players.list.length; ++i) {
      tmpObj = this.players.list[i];
      if (tmpObj.active || tmpObj.spectating) {
        io.send(tmpObj.id, "ex", Math.round(x), Math.round(y), Math.round(z), Math.round(s));
        if (tmpObj.active) {
          var tmpDst = UTILS.getDistance3D(x, y, z, tmpObj.x, tmpObj.y, tmpObj.z);
          var tmpMlt = 1 - tmpDst / s;
          if (tmpMlt > 0) {
            if (this.players.changeHealth(tmpObj, owner, dmg * tmpMlt, owner == tmpObj)) {
              this.players.kill(tmpObj, owner, {
                dst: tmpDst
              });
            }
            ;
          }
        }
      }
    }
  };

  // GET SPAWN POINT:
  var tmpPoints = [];
  this.getSpawnPoint = function (team, player, skip) {
    if (skip) {
      return this.map.spawns[0];
    }
    tmpPoints.length = 0;
    var lowestLOS = 100;
    var tmpC = 0;
    for (var i = 0; i < this.map.spawns.length; ++i) {
      this.map.spawns[i].dst = 0;
      for (var p = 0; p < this.players.list.length; ++p) {
        tmpObj = this.players.list[p];
        if (tmpObj && tmpObj.active && tmpObj != player && !(team && tmpObj.team == team) && !this.canSee(tmpObj, this.map.spawns[i].x, this.map.spawns[i].y + config.playerHeight, this.map.spawns[i].z)) {
          this.map.spawns[i].dst++;
          tmpC++;
        }
      }
    }
    this.map.spawns.sort(UTILS.orderByDst);
    lowestLOS = this.map.spawns[0].dst;
    for (var i = 0; i < this.map.spawns.length; ++i) {
      if (this.map.spawns[i].dst == lowestLOS) {
        this.map.spawns[i].dst = 0;

        // PLAYERS:
        for (var p = 0; p < this.players.list.length; ++p) {
          tmpObj = this.players.list[p];
          if (tmpObj.active && tmpObj != player && !(team && tmpObj.team == team)) {
            this.map.spawns[i].dst += UTILS.getDistance3D(this.map.spawns[i].x, this.map.spawns[i].y, this.map.spawns[i].z, tmpObj.x, tmpObj.y, tmpObj.z);
          }
        }

        // FLAGS:
        if (this.mode && this.mode.flags) {
          for (var f = 0; f < this.map.manager.flags.length; ++f) {
            tmpObj = this.map.manager.flags[f];
            this.map.spawns[i].dst += UTILS.getDistance3D(this.map.spawns[i].x, this.map.spawns[i].y, this.map.spawns[i].z, tmpObj.x, tmpObj.y, tmpObj.z) * (tmpObj.team != team ? 1 : -1);
          }
        }

        // ADD SPAWN:
        if (team && this.map.spawns[i].team == team || !this.map.spawns[i].team) {
          tmpPoints.push(this.map.spawns[i]);
        }
      }
    }
    tmpPoints.sort(UTILS.orderByDst);
    tmpPoints.reverse();
    return tmpPoints[0] || this.map.spawns[0];
  };

  // PLAYER CAN SEE SOMETHING:
  this.canSee = function (player, x2, y2, z2, pad) {
    if (!player) {
      return false;
    }

    // CONSTANTS:
    pad = pad || 0;
    var td = UTILS.getDistance3D(player.x, player.y, player.z, x2, y2, z2);
    var xDr = UTILS.getDirection(player.z, player.x, z2, x2);
    var yDr = UTILS.getDirection(UTILS.getDistance(player.x, player.z, x2, z2), y2, 0, player.y);
    var dx = 1 / (td * Math.sin(xDr - Math.PI) * Math.cos(yDr));
    var dz = 1 / (td * Math.cos(xDr - Math.PI) * Math.cos(yDr));
    var dy = 1 / (td * Math.sin(yDr));
    var startY = player.y + player.height - config.cameraHeight;

    // FIND VISIBLE OBJECTS:
    for (var x = 0; x < this.map.manager.objects.length; ++x) {
      var tObj = this.map.manager.objects[x];
      if (!tObj.noShoot && tObj.active && !tObj.transparent) {
        // LINE OF SIGHT:
        var tmpDst = UTILS.lineInRect(player.x, player.z, startY, dx, dz, dy, tObj.x - Math.max(0, tObj.width - pad), tObj.z - Math.max(0, tObj.length - pad), tObj.y - Math.max(0, tObj.height - pad), tObj.x + Math.max(0, tObj.width - pad), tObj.z + Math.max(0, tObj.length - pad), tObj.y + Math.max(0, tObj.height - pad));
        if (tmpDst && tmpDst < 1) {
          return tmpDst;
        }
      }
    }

    // RAYCAST TERRAIN:
    var terrain = this.map.terrain;
    if (terrain) {
      var terrainRaycast = terrain.raycast(player.x, -player.z, startY, 1 / dx, -1 / dz, 1 / dy);
      if (terrainRaycast) {
        return UTILS.getDistance3D(player.x, player.y, player.z, terrainRaycast.x, terrainRaycast.z, -terrainRaycast.y);
      }
    }
    return null;
  };

  // UPDATE ACCOUNTS:
  this.updateAccounts = function () {
    var rewardsToSave = [];
    for (var i = 0; i < this.players.list.length; ++i) {
      tmpObj = this.players.list[i];
      if (tmpObj.account && !tmpObj.account.hack) {
        tmpObj.account.timePlayed += tmpObj.playTime || 0;
        if (this.host == undefined) {
          tmpObj.account.games++;
          tmpObj.account.kills += tmpObj.kills;
          tmpObj.account.deaths += tmpObj.deaths;
          tmpObj.account.score += tmpObj.score;
          if (tmpObj.didWin) {
            tmpObj.account.wins++;
          }
        }
        io.send(tmpObj.id, "ua", tmpObj.account.getData());
        rewardsToSave.push(tmpObj);
      }
    }
    if (rewardsToSave.length) {
      this.saveRewards(rewardsToSave);
    }
  };

  // SAVE REWARDS:
  this.saveRewards = function (list) {
    var tmpString = "";
    for (var i = 0; i < list.length; ++i) {
      if (list[i] && list[i].account && list[i].reward) {
        tmpString += (tmpString.length ? "," : "") + list[i].account.id + "," + list[i].reward;
      }
    }
    if (tmpString.length) {
      DATABASE.call(20, [tmpString], function (error, response) {
        if (response && response[0] && response[0][0]) {
          response = response[0][0].result;
          if (response) {
            try {
              response = response.split(",");
              for (var i = 0; i < response.length; ++i) {
                var tmpFunds = parseInt(response[i]);
                if (tmpFunds && list[i]) {
                  list[i].account.funds = tmpFunds;
                  io.send(list[i].id, "uf", tmpFunds);
                }
              }
            } catch (e) {}
          }
        }
      });
    }
  };

  // INCREASE PLAYER STAT:
  this.incStat = function (stat, player) {
    if (player && player.account && this.host == undefined) {
      if (!player.account.stats[stat]) {
        player.account.stats[stat] = 0;
      }
      player.account.stats[stat]++;
    }
  };

  // SAVE PLAYER DATA:
  this.savePlayerData = function (player) {
    if (DATABASE && player.account) {
      var tmpData = player.account;
      if (tmpData) {
        DATABASE.call(2, [tmpData.id, tmpData.kills, tmpData.wins, tmpData.games, tmpData.deaths, tmpData.score, tmpData.clan, tmpData.timePlayed, JSON.stringify(tmpData.stats)]);
      }
    }
  };

  // LOCK PLAYER:
  this.lockPlayer = function (player, locked) {
    player.locked = locked;
    io.send(tmpObj.id, "lock", locked);
  };

  // UPDATE TEAM:
  this.updateTeam = function (player, team) {
    player.team = team;
    for (var i = 0; i < player.sentTo.length; ++i) {
      io.send(player.sentTo[i], "tm", player.sid, team);
    }
    this.players.syncLeaders();
  };

  // START NUKE:
  this.startNuke = function (player) {
    this.nukeTimer = 10000;
    this.nukePlayer = player;
    io.broadcast("game" + this.sid, "n", 0);
  };

  // INFECT RANDOM:
  var tmpList = [];
  this.infectRandom = function () {
    tmpList.length = 0;
    for (var i = 0; i < this.players.list.length; ++i) {
      if (this.players.list[i].active) {
        tmpList.push(i);
      }
    }
    var infectCount = 1;
    if (tmpList.length >= 14) {
      infectCount = 3;
    } else {
      if (tmpList.length >= 8) {
        infectCount = 2;
      }
    }
    for (var i = 0; i < infectCount; ++i) {
      var tmpIndx = UTILS.randInt(0, tmpList.length - 1);
      tmpObj = this.players.list[tmpList[tmpIndx]];
      if (tmpObj) {
        this.players.kill(tmpObj, null, null, true);
        io.broadcast("game" + this.sid, "ac", tmpObj.sid, null, "got infected");
      }
      tmpList.splice(tmpIndx, 1);
    }
  };

  // SIMON SAYS:
  this.pickSimon = function () {
    tmpList.length = 0;
    var tmpSim = null;
    for (var i = 0; i < this.players.list.length; ++i) {
      if (this.players.list[i].active) {
        if (this.host == this.players.list[i].id) {
          tmpSim = this.players.list[i];
          break;
        } else {
          tmpList.push(i);
        }
      }
    }
    if (!tmpSim) {
      tmpSim = this.players.list[tmpList[UTILS.randInt(0, tmpList.length - 1)]];
    }
    if (tmpSim) {
      this.updateTeam(tmpSim, "simon");
      tmpSim.maxHealth = 5000;
      tmpSim.health = tmpSim.maxHealth;
      io.send(tmpSim.id, "h", tmpSim.health);
    }
  };

  // BOSS MODE:
  this.pickBoss = function () {
    tmpList.length = 0;
    for (var i = 0; i < this.players.list.length; ++i) {
      if (this.players.list[i].active) {
        tmpList.push(i);
      }
    }
    tmpObj = this.players.list[tmpList[UTILS.randInt(0, tmpList.length - 1)]];
    if (tmpObj) {
      this.updateTeam(tmpObj, "boss");
      tmpObj.maxHealth = 5000;
      tmpObj.health = tmpObj.maxHealth;
      io.send(tmpObj.id, "h", tmpObj.health);
    }
  };

  // HIDE & SEEK:
  this.pickSeeker = function () {
    tmpList.length = 0;
    for (var i = 0; i < this.players.list.length; ++i) {
      if (this.players.list[i].active) {
        tmpList.push(i);
      }
    }
    tmpObj = this.players.list[tmpList[UTILS.randInt(0, tmpList.length - 1)]];
    if (tmpObj) {
      this.updateTeam(tmpObj, "seek");
      this.lockPlayer(tmpObj, true);
    }
  };
  this.releaseSeeker = function () {
    for (var i = 0; i < this.players.list.length; ++i) {
      tmpObj = this.players.list[i];
      if (tmpObj.team == "seek") {
        this.lockPlayer(tmpObj, false);
      }
    }
  };

  // DESTROY OBJECT:
  this.destroyObj = function (uid) {
    for (var i = 0; i < context.map.manager.objects.length; ++i) {
      tmpObj = context.map.manager.objects[i];
      if (tmpObj.uid == uid) {
        tmpObj.active = false;
        if (tmpObj.meshRef) {
          tmpObj.meshRef.visible = false;
        }
        if (RENDER) {
          RENDER.updateShadowMap();
        }
        break;
      }
    }
  };

  // CAP FLAG:
  this.capFlag = function (player, flag) {
    if (io) {
      player.caps++;
      player.flag = null;
      if (!this.teams[player.team]) {
        this.teams[player.team] = 1;
      } else {
        this.teams[player.team]++;
      }
      io.broadcast("game" + this.sid, "ts", player.team, this.teams[player.team]);
      io.broadcast("game" + context.sid, "ac", player.sid, null, "captured the Flag");
      io.send(player.id, "am", ["Capture", 150]);
      this.players.score(player, 150);
      this.resetFlag(flag);
    }
  };

  // UPDATE FLAG COLOR:
  this.updateFlagCol = function (flag, player) {
    if (player && player.team && flag.teamCol != player.team && flag.meshRef) {
      flag.teamCol = player.team;
      flag.meshRef.material = RENDER.getMat("crystal_0", context.map.manager.getFlagDat(flag.team, player));
      flag.meshRef.zoneMesh.material = RENDER.getMat("zone_r", context.map.manager.getZoneDat(flag.team, player));
    }
  };

  // UPDATE FLAGS ON CLIENT:
  this.updateFlags = function (player, delta) {
    if (context.mode && context.mode.flags) {
      var youHave = false;
      var theyHave = false;
      for (var i = 0; i < context.map.manager.flags.length; ++i) {
        tmpObj = context.map.manager.flags[i];
        if (tmpObj.meshRef) {
          if (player) {
            context.updateFlagCol(tmpObj, player);
          }
          if (tmpObj.carrier) {
            if (player && tmpObj.team == player.team) {
              theyHave = true;
            }
            if (player && tmpObj.carrier == player.sid) {
              youHave = true;
            }
            tmpObj2 = context.players.findBySid(tmpObj.carrier);
            if (tmpObj2) {
              RENDER.moveMesh(tmpObj.meshRef, tmpObj2.x, tmpObj2.y + config.flagHOff, tmpObj2.z);
            }
          } else {
            RENDER.moveMesh(tmpObj.meshRef, tmpObj.x, tmpObj.y, tmpObj.z);
          }
          tmpObj.bobAnimY = (tmpObj.bobAnimY || 0) + 0.003 * delta;
          tmpObj.meshRef.position.y += Math.cos(tmpObj.bobAnimY);
          tmpObj.meshRef.rotation.y += 0.002 * delta;
        }
      }

      // FLAG INFO TEXT:
      if (theyHave && youHave) {
        if (gameMessage.innerHTML != config.flagMsgRC) {
          gameMessage.innerHTML = config.flagMsgRC;
        }
      } else {
        if (theyHave) {
          if (gameMessage.innerHTML != config.flagMsgE) {
            gameMessage.innerHTML = config.flagMsgE;
          }
        } else {
          if (youHave) {
            if (gameMessage.innerHTML != config.flagMsg) {
              gameMessage.innerHTML = config.flagMsg;
            }
          } else {
            if (gameMessage.innerHTML != "") {
              gameMessage.innerHTML = "";
            }
          }
        }
      }
      specGameMessage.innerHTML = gameMessage.innerHTML;
    }
  };

  // UPDATE FLAG:
  this.updateFlag = function (uid, x, y, z, car) {
    for (var i = 0; i < context.map.manager.flags.length; ++i) {
      tmpObj = context.map.manager.flags[i];
      if (tmpObj.uid == uid) {
        tmpObj.carrier = car;
        context.moveObj(tmpObj, x, y, z);
        break;
      }
    }
  };

  // DROP FLAG:
  this.dropFlag = function (flag) {
    if (io && flag && flag.carrier) {
      var holder = this.players.findBySid(flag.carrier);
      this.updateCarrier(flag);
      if (holder) {
        io.broadcast("game" + context.sid, "ac", holder.sid, null, "dropped the Flag");
        holder.flag = null;
        this.updateObjPos(flag, holder.x, holder.y + config.flagOff, holder.z);
      } else {
        this.updateObjPos(flag, flag.orgX, flag.orgY, flag.orgZ);
      }
    }
  };

  // PICKUP FLAG:
  this.pickupFlag = function (player, flag) {
    if (io && context.mode && context.mode.flags) {
      if (!flag.carrier) {
        if (player.team == flag.team) {
          if (flag.x != flag.orgX || flag.y != flag.orgY || flag.z != flag.orgZ) {
            io.broadcast("game" + context.sid, "ac", player.sid, null, "returned the Flag");
            io.send(player.id, "am", ["Return", 50]);
            this.players.score(player, 50);
            this.resetFlag(flag);
          }
        } else {
          if (!player.flag) {
            io.send(player.id, "am", ["Pickup", 20]);
            this.players.score(player, 20);
            this.updateCarrier(flag, player);
            io.broadcast("game" + context.sid, "ac", player.sid, null, "got the Flag");
          }
        }
      }
    }
  };

  // SYNC FLAG:
  this.syncFlag = function (flag) {
    io.broadcast("game" + context.sid, "ufl", flag.uid, flag.x.round(1), flag.y.round(1), flag.z.round(1), flag.carrier || 0);
  };

  // UPDATE FLAG CARRIER:
  this.updateCarrier = function (flag, player) {
    flag.carrier = player ? player.sid : 0;
    if (player) {
      player.flag = flag;
    }
    this.syncFlag(flag);
  };

  // RESET FLAG:
  this.resetFlags = function () {
    for (var i = 0; i < context.map.manager.flags.length; ++i) {
      tmpObj = context.map.manager.flags[i];
      tmpObj.carrier = 0;
      tmpObj.x = tmpObj.orgX;
      tmpObj.y = tmpObj.orgY;
      tmpObj.z = tmpObj.orgZ;
      if (tmpObj.meshRef) {
        var isVis = !!(context.mode && context.mode.flags);
        tmpObj.meshRef.visible = isVis;
        tmpObj.meshRef.zoneMesh.visible = isVis;
      }
    }
  };
  this.resetFlag = function (flag) {
    this.updateObjPos(flag, flag.orgX, flag.orgY, flag.orgZ);
    this.updateCarrier(flag);
  };
  this.updatePickup = function (uid, wid, org, pos) {
    for (var i = 0; i < this.map.manager.pickups.length; ++i) {
      tmpObj = this.map.manager.pickups[i];
      if (tmpObj.uid == uid) {
        if (RENDER) {
          tmpObj2 = tmpObj.meshRef;
          var newPos = pos ? pos : [tmpObj2.position.x, tmpObj2.position.y, tmpObj2.position.z];
          RENDER.scene.remove(tmpObj.meshRef);
          tmpObj.meshRef = RENDER.loadMesh({
            src: "weapons/" + this.weapons[wid || 0].src,
            texSrc: "weapons/" + this.weapons[wid || 0].src,
            noGroup: true,
            noShadow: true,
            transparent: true,
            noFog: true
          }, ...newPos, 0, this.weapons[wid || 0].scale, RENDER.scene);
          tmpObj.meshRef.rotation.copy(tmpObj2.rotation.clone());
          tmpObj.meshRef.visible = wid != undefined ? true : false;
        }
        tmpObj.x = pos ? pos[0] : tmpObj.orgX;
        tmpObj.y = pos ? pos[1] : tmpObj.orgY;
        tmpObj.z = pos ? pos[2] : tmpObj.orgZ;
        if (org) {
          tmpObj.orgPickup = org;
        }
        tmpObj.pickup = wid;
        break;
      }
    }
  };
  this.resetPickups = function () {
    for (var i = 0; i < context.map.manager.pickups.length; ++i) {
      tmpObj = context.map.manager.pickups[i];
      tmpObj.pickup = tmpObj.orgPickup;
      tmpObj.x = tmpObj.orgX;
      tmpObj.y = tmpObj.orgY;
      tmpObj.z = tmpObj.orgZ;
      if (RENDER) {
        tmpObj2 = tmpObj.meshRef;
        RENDER.scene.remove(tmpObj.meshRef);
        tmpObj.meshRef = RENDER.loadMesh({
          src: "weapons/" + context.weapons[tmpObj.pickup].src,
          texSrc: "weapons/" + context.weapons[tmpObj.pickup].src,
          noGroup: true,
          noShadow: true,
          transparent: true,
          noFog: true
        }, tmpObj.x, tmpObj.y - config.pickupZoneH / 2 + config.pickupOff, tmpObj.z, 0, context.weapons[tmpObj.pickup].scale, RENDER.scene);
        tmpObj.meshRef.rotation.copy(tmpObj2.rotation.clone());
        tmpObj.meshRef.visible = true;
      }
    }
  };
  this.increaseWeapon = function (player) {
    tmpObj = [...player.loadout];
    tmpObj.length = 1;
    if (player.killList.indexOf(tmpObj[0]) == -1) {
      player.killList.push(tmpObj[0]);
      var index = this.mode.weaponOrder.indexOf(tmpObj[0]);
      index++;
      if (!(index > this.mode.weaponOrder.length - 1)) {
        tmpObj[0] = this.mode.weaponOrder[index];
      }
      player.updateLoadout(this, 0, true, ...tmpObj);
      io.broadcast("game" + this.sid, "inat", player.sid, tmpObj, 0, undefined, undefined, false);
      this.players.score(player, 1, true);
    }
  };
  this.decreaseWeapon = function (player) {
    player.killList.pop();
    tmpObj = [...player.loadout];
    tmpObj.length = 1;
    var index = this.mode.weaponOrder.indexOf(tmpObj[0]);
    index--;
    if (!(index < 0)) {
      tmpObj[0] = this.mode.weaponOrder[index];
    }
    player.updateLoadout(this, 0, true, ...tmpObj);
    io.broadcast("game" + this.sid, "inat", player.sid, tmpObj, 0, undefined, undefined, false);
    if (index >= 0) {
      this.players.score(player, -1);
      player.setbacks++;
    }
  };

  // UPDATE OBJECT POS:
  this.updateObjPos = function (obj, x, y, z) {
    obj.x = x;
    obj.y = y;
    obj.z = z;
    this.syncFlag(obj);
  };

  // UPDATE BR ZONE:
  this.updateZone = function (size) {
    context.map.zone.update(size);
  };

  // RESET BR ZONE:
  this.resetZone = function () {
    if (context.map.zone) {
      context.map.zone.reset();
    }
  };

  // SET OBJECTIVE:
  this.setObjective = function (index) {
    try {
      context.activeObjective = index;
      for (var i = 0; i < context.map.manager.objectives.length; ++i) {
        context.map.manager.objectives[i].mesh.visible = index == i;
      }
    } catch (e) {}
  };

  // NEXT OBJECTIVE:
  this.nextObjective = function (timeM) {
    this.activeObjective++;
    if (this.activeObjective >= this.map.manager.objectives.length) {
      this.activeObjective = 0;
    }
    io.broadcast("game" + this.sid, "obj", this.activeObjective);
    if (this.map.manager.objectives.length > 1) {
      this.waitTimers = [{
        time: 60000 - (timeM || 0),
        contTime: true,
        canDMG: true,
        msg: "next objective ",
        trigger: function (game, t) {
          game.nextObjective(t);
        }
      }];
    }
  };

  // SET CHECK POINT
  this.setCheckPoint = function (player, obj) {
    tmpObj = {
      x: obj.x,
      y: obj.y,
      z: obj.z,
      dir: obj.dir
    };
    tmpObj2 = Object.values(tmpObj).join(',');
    if (player.checkPoint) {
      if (Object.entries(player.checkPoint).toString() === Object.entries(tmpObj).toString()) {
        return; // SKIP POPUP MESSAGE
      }
    }
    if (obj.singleUse) {
      if (player.checkPointList.includes(tmpObj2)) {
        return;
      }
      player.checkPointList.push(tmpObj2);
    }
    player.checkPoint = tmpObj;
    if (io) {
      io.send(player.id, "chp");
    }
  };

  // TELEPORT PLAYER
  this.checkTeleport = function (player, obj) {
    // STEPPED ON RECIEVING NODE DO NOTHING
    if (obj.node == 1 || obj.telCooldown > 0) {
      return;
    }
    var objs = [];
    for (var i = 0; i < this.map.manager.teleporters.length; ++i) {
      tmpObj = this.map.manager.teleporters[i];
      if (tmpObj.channel == obj.channel && tmpObj.node > 0 && obj.uid != tmpObj.uid) {
        objs.push(tmpObj);
      }
    }
    if (!objs.length) {
      return;
    }
    var res = objs[0]; //UTILS.getRandom(objs);
    if (!res) {
      return;
    }
    if (res.node == 2) {
      res.telCooldown = 2000;
    }
    player.x = player.oldX = res.x;
    player.y = player.oldY = res.y - res.height;
    player.z = player.oldZ = res.z;
    if (res.telStopMo) {
      player.lastX = res.x;
      player.lastY = res.y - res.height;
      player.lastZ = res.z;
      player.stepVal = 0;
      player.xVel = 0;
      player.yVel = 0;
      player.zVel = 0;
    }
    //player.xDire = -((tmpObj.dir||0) + 1) * Math.PI / 2;
    //if (io) io.send(player.id, "cd", player.xDire);
  };

  // UPDATE TELEPORTER TIMER
  this.updateTeleporters = function (delta) {
    if (context.map.manager.teleporters.length) {
      for (var i = 0; i < context.map.manager.teleporters.length; ++i) {
        tmpObj = context.map.manager.teleporters[i];
        tmpObj.telCooldown -= delta;
        if (tmpObj.telCooldown <= 0) {
          tmpObj.telCooldown = 0;
        }
      }
    }
  };

  // UPDATE UI:
  this.updateUI = function () {
    killCount.style.display = this.mode.friendly ? "none" : "inline-block";
  };

  // CREATE INSTANCE CONFIG:
  this.instanceConfig = function () {};

  // VOTE ON MODE:
  this.voteMode = function (id, index) {
    if (this.endData.vo) {
      if (this.endData.vo[id] != index) {
        this.endData.vo[id] = index;
      } else {
        this.endData.vo[id] = null;
      }
      io.broadcast("game" + this.sid, "mv", this.endData.vo);
    }
  };

  // INIT:
  var tmpVotes = [];
  this.init = function (mapIndex, modeIndex, force) {
    // REMOVE PLAYERS:
    this.players.clear();

    // RESET TEAMS:
    this.teams = {};

    // MODE VOTES:
    tmpVotes.length = 0;
    for (var i = 0; i < this.map.modes.length; ++i) {
      var tmpC = 0;
      tmpVotes[i] = 0;
      if (this.endData.vo) {
        for (var vote in this.endData.vo) {
          if (this.endData.vo.hasOwnProperty(vote)) {
            if (i == this.endData.vo[vote]) {
              tmpVotes[i]++;
            }
          }
        }
      }
    }
    var maxV = 0;
    var votedMode = null;
    for (var i = 0; i < tmpVotes.length; ++i) {
      if (tmpVotes[i] > maxV) {
        maxV = tmpVotes[i];
        votedMode = i;
      }
    }

    // PICK MAP AND MODE:
    if (votedMode != null) {
      this.modeIndex = votedMode;
    } else {
      this.modeIndex = modeIndex != undefined ? modeIndex : this.config.modes ? this.config.modes[UTILS.randInt(0, this.config.modes.length - 1)] : UTILS.randInt(0, 3);
    }
    this.mapIndex = mapIndex != undefined ? mapIndex : this.config.maps[UTILS.randInt(0, this.config.maps.length - 1)];

    // GENERATE MAP:
    this.destObjs.length = 0;
    this.mode = mapData.modes[this.modeIndex];
    this.map.generate(this.mapIndex, this.mode, force);
    this.resetFlags();
    this.resetPickups();
    this.resetZone();

    // SET LIVES FROM MODE:
    if (!this.config.lives && this.mode.lives) {
      this.config.lives = this.mode.lives;
    }

    // MIN PLAYERS:
    this.minPlayers = this.config.minPlayers || this.mode.minPlayers;
    if (!this.minPlayers && this.config.lives) {
      this.minPlayers = 2;
    }

    // TIMERS:
    this.zoneTimer = 0;
    this.nukeTimer = 0;
    this.objectiveTimer = 0;
    this.activeObjective = null;
    this.gameTimer = this.mode.gameTime != undefined ? this.mode.gameTime : this.config.gameTime * 60000;
    this.lastTimer = 0;
    this.lastTimerW = 0;
    this.waitTimers = null;
    if (this.mode.waitTimers) {
      this.waitTimers = [];
      for (var i = 0; i < this.mode.waitTimers.length; ++i) {
        this.waitTimers.push({
          time: this.mode.waitTimers[i].time,
          trigger: this.mode.waitTimers[i].trigger,
          msg: this.mode.waitTimers[i].msg
        });
      }
    } else {
      if (this.config.lives) {
        this.waitTimers = [{
          time: 20000,
          msg: "match starts in ",
          trigger: function (g) {
            for (var i = 0; i < g.players.list.length; ++i) {
              if (g.players.list[i].spectating) {
                g.players.list[i].lives = 0;
              }
            }
          }
        }];
      }
    }

    // CONDITION OVERRIDE:
    this.condition = this.mode.condition;
    if (this.config.lives) {
      // START CONDITION:
      if (!this.condition) {
        if (!this.mode.teams) {
          this.condition = function (g) {
            var pCnt = 0;
            for (var i = 0; i < g.players.list.length; ++i) {
              if (g.players.list[i].lives > 0) {
                pCnt++;
              }
            }
            return pCnt > 1;
          };
        } else {
          this.condition = function (g) {
            var t1C = 0;
            var t2C = 0;
            for (var i = 0; i < g.players.list.length; ++i) {
              if (g.players.list[i].lives > 0) {
                if (g.players.list[i].team == 1) {
                  t1C++;
                } else {
                  t2C++;
                }
              }
            }
            return t1C >= 1 && t2C >= 1;
          };
        }
      }

      // WIN CONDITION:
      if (!this.winCondition) {
        if (!this.mode.teams) {
          this.winCondition = function (g) {
            for (var i = 0; i < g.players.list.length; ++i) {
              if (g.players.list[i].lives > 0) {
                return g.players.list[i];
              }
            }
            return null;
          };
        } else {
          this.winCondition = function (g) {
            for (var i = 0; i < g.players.list.length; ++i) {
              if (g.players.list[i].team && g.players.list[i].lives > 0) {
                return g.players.list[i].team;
              }
            }
            return 1;
          };
        }
      }
    }

    // STATS:
    this.kills = 0;

    // GAME START OVERRIDE:
    if (io && this.mode.gameStart) {
      this.mode.gameStart(this);
    }

    // PLAY MAP SOUNDS: TODO: STOP OLD MAP SOUND
    if (SOUND) {
      var ambInd = this.map.maps[this.mapIndex].ambInd || 1;
      ambInd = parseInt(ambInd);
      for (var i = 1; i < 4; ++i) {
        SOUND.stop("ambient_" + i);
      }
      SOUND.play("ambient_" + ambInd, 0.12, true, 1);
    }

    // GAME INSTANCE:
    if (serverManager) {
      let gameConfig = {
        mC: this.maxPlayers,
        pv: this.private,
        sk: !this.isCustom,
        data: {
          cs: this.isCustom,
          i: this.getInfo(),
          version: gameVersion
        }
      };
      if (this.gameInstance) {
        // UPDATE EXISTING GAME:
        this.gameInstance.update(gameConfig);
      } else {
        // CREATE NEW GAME:
        this.gameInstance = serverManager.createGame(serverPort, gameConfig);

        // WATCH FOR VERSION CHANGES
        if (io && !config.isProd) {
          function myRequire(path) {
            return require("../data sync recursive.js")(path);
          }
          var path = myRequire("path");
          var fs = myRequire("fs");
          var versionPath = path.join(__dirname, "..", "..", "version.json");

          // WATCH FILE:
          fs.watchFile(versionPath, {
            interval: 100
          }, _ => {
            gameConfig.data.version = gameVersion = JSON.parse(fs.readFileSync(versionPath, "utf8"));
            this.gameInstance.update(gameConfig);
          });
        }
      }
    }
  };

  // GET TEAM SCORES:
  this.getTeamScores = function () {
    var tmpScores = null;
    if (this.mode && this.mode.teams && this.teams) {
      tmpScores = [[1, this.teams[1] || 0], [2, this.teams[2] || 0]];
    }
    return tmpScores;
  };

  // GET SYNC DATA:
  this.getSyncData = function () {
    var tmpFlags = [];
    var tmpPickups = [];
    for (var i = 0; i < this.map.manager.flags.length; ++i) {
      tmpObj = this.map.manager.flags[i];
      tmpFlags.push([tmpObj.uid, tmpObj.x.round(1), tmpObj.y.round(1), tmpObj.z.round(1), tmpObj.carrier || 0]);
    }
    for (var i = 0; i < this.map.manager.pickups.length; ++i) {
      tmpObj = this.map.manager.pickups[i];
      tmpPickups.push([tmpObj.uid, tmpObj.pickup, tmpObj.orgPickup || 0, [tmpObj.x, tmpObj.y, tmpObj.z]]);
    }
    return {
      dest: this.destObjs.length ? this.destObjs : 0,
      flg: tmpFlags.length ? tmpFlags : 0,
      pkups: tmpPickups.length ? tmpPickups : 0,
      zone: this.map.zone ? this.map.zone.scale : 0
    };
  };

  // END GAME:
  this.endGame = function () {
    this.endTimer = config.endTimer;
    this.waitTimers = null;
    if (this.mode.endSort) {
      this.players.list.sort(this.mode.endSort);
    } else {
      this.players.list.sort(UTILS.orderByScore);
    }
    if (this.host == undefined || this.earnKR) {
      for (var i = 0; i < this.players.list.length; ++i) {
        tmpObj = this.players.list[i];
        tmpObj.reward = 0;
        if (tmpObj.account) {
          if (this.earnKR) {
            tmpObj.reward = Math.min(10, Math.floor(tmpObj.score / 100));
          } else {
            tmpObj.reward = Math.min(30, Math.floor(tmpObj.score / 100));
          }
          if (tmpObj.challMode) {
            tmpObj.reward = Math.floor(tmpObj.reward * 1.5);
          }
        }
      }
    }
    this.endData.ed.length = 0;
    var endStats = this.mode.endStats || config.endStats;
    for (var i = 0; i < this.players.list.length; ++i) {
      for (var x = 0; x < endStats.length; ++x) {
        this.endData.ed.push(config.endForm[endStats[x]] ? config.endForm[endStats[x]](this.players.list[i][endStats[x]], this, this.players.list[i]) : this.players.list[i][endStats[x]]);
      }
    }
    if (this.mode.winCondition) {
      this.winner = this.mode.winCondition(this);
    } else {
      if (this.mode.teams && this.teams) {
        var topTeam = 0;
        var tmpWin = null;
        for (var tm in this.teams) {
          if (this.teams.hasOwnProperty(tm) && this.teams[tm] >= topTeam) {
            topTeam = this.teams[tm];
            tmpWin = tm;
          }
        }
        this.winner = tmpWin;
      } else {
        this.winner = this.players.list[0];
      }
    }
    this.endData.vo = {};
    for (var i = 0; i < this.players.list.length; ++i) {
      tmpObj = this.players.list[i];
      tmpObj.didWin = tmpObj.team && tmpObj.team == this.winner || tmpObj == this.winner;
      tmpObj.reset();
      io.send(tmpObj.id, "end", false, tmpObj.didWin, this.endData);
    }
    this.updateAccounts();
    this.players.clear();
  };

  // UPDATE FUNCTION:
  this.update = function (delta, now, player) {
    this.now = now;

    // TIMERS:
    if (io) {
      var progTime = true;
      if (this.endTimer > 0) {
        progTime = false;
        this.endTimer -= delta;
        if (this.endTimer <= 0) {
          this.init();
          this.endTimer = 0;
          io.broadcast("game" + this.sid, "init", this.mapIndex, this.modeIndex, this.getTeamScores(), this.activeObjective, this.host, this.config, 0, this.customMapData ? 1 : null, this.getSyncData());
          if (this.isPrimary) {
            UTILS.restartIfNeeded(io);
          }
        } else {
          tmpTimer = UTILS.getTime(this.endTimer);
          if (tmpTimer != this.lastTimer) {
            this.lastTimer = tmpTimer;
            io.broadcast("game" + this.sid, "t", tmpTimer, 1);
          }
        }
      } else {
        if (this.waitTimers) {
          progTime = false;
          if (!(this.minPlayers && this.players.activeCount() < this.minPlayers)) {
            this.waitTimers[0].time -= delta;
            if (this.waitTimers[0].time <= 0) {
              if (this.waitTimers[0].trigger) {
                this.waitTimers[0].trigger(this, -this.waitTimers[0].time);
              }
              if (this.waitTimers[0].time <= 0) {
                this.waitTimers.splice(0, 1);
                if (!this.waitTimers.length) {
                  this.waitTimers = null;
                  io.broadcast("game" + this.sid, "gmsg");
                }
              }
            } else {
              tmpTimer = UTILS.getTime(this.waitTimers[0].time);
              if (tmpTimer != this.lastTimerW) {
                this.lastTimerW = tmpTimer;
                io.broadcast("game" + this.sid, "gmsg", this.waitTimers[0].msg + tmpTimer);
              }
            }
          } else {
            io.broadcast("game" + this.sid, "gmsg", "wt");
          }
        }
      }
      if (this.endTimer <= 0 && (progTime || this.waitTimers && this.waitTimers[0].contTime)) {
        if (this.condition && !this.condition(this)) {
          this.gameTimer = "skip";
        }
        if (this.gameTimer != "skip" && this.mode.timed) {
          this.gameTimer += delta;
          tmpTimer = UTILS.getTime(this.gameTimer, this.mode.showMS);
          if (tmpTimer != this.lastTimer) {
            this.lastTimer = tmpTimer;
            io.broadcast("game" + this.sid, "t", tmpTimer);
          }
        } else {
          if (this.gameTimer > 0 || this.gameTimer == "skip") {
            if (this.gameTimer != "skip") {
              this.gameTimer -= delta;
            }
            if (this.gameTimer == "skip" || this.gameTimer <= 0) {
              this.gameTimer = 0;
              this.endGame();
            } else {
              tmpTimer = UTILS.getTime(this.gameTimer, this.mode.showMS);
              if (tmpTimer != this.lastTimer) {
                this.lastTimer = tmpTimer;
                io.broadcast("game" + this.sid, "t", tmpTimer);
              }
            }
          }
        }
      }

      // NUKE TIMER:
      if (this.endTimer <= 0 && this.nukeTimer) {
        this.nukeTimer -= delta;
        if (this.nukeTimer <= 0) {
          this.nukeTimer = 0;
          io.broadcast("game" + this.sid, "n", 1);
          if (this.nukePlayer) {
            var nukeScore = 0;
            for (var i = 0; i < this.players.list.length; ++i) {
              tmpObj = this.players.list[i];
              if (tmpObj.active && tmpObj != this.nukePlayer && !(tmpObj.team && this.nukePlayer.team == tmpObj.team)) {
                nukeScore += 50;
                this.players.kill(tmpObj, this.nukePlayer, null, false, true);
              }
            }
            if (nukeScore) {
              io.send(this.nukePlayer.id, "6", ["Nuke", nukeScore], 0, this.nukePlayer.kills);
              io.send(this.nukePlayer.id, "4");
              this.players.score(this.nukePlayer, nukeScore);
            }
          }
        }
      }
    }

    // UPDATE PLAYERS:
    this.players.update(delta * this.config.deltaMlt);

    // UPDATE TELEPORTERS:
    this.updateTeleporters(delta);

    // OBJECTIVES:
    if (io && this.mode.objective && this.map.manager.objectives.length) {
      this.objectiveTimer -= delta;
      if (this.objectiveTimer <= 0) {
        this.objectiveTimer = 1500; // EVERY 1.5s
        for (var i = 0; i < this.map.manager.objectives.length; ++i) {
          tmpObj = this.map.manager.objectives[i];
          if (i == this.activeObjective) {
            for (var x = 0; x < this.players.list.length; ++x) {
              tmpObj2 = this.players.list[x];
              if (tmpObj2.active && tmpObj2.collides(tmpObj)) {
                this.players.score(tmpObj2, 10);
              }
            }
          }
        }
      }
    }

    // ZONE:
    if (this.map.zone) {
      if (io) {
        this.zoneTimer -= delta;
        if (this.zoneTimer <= 0) {
          // ZONE SHRINKING:
          this.zoneTimer = 1000;
          this.map.zone.shrink();
          io.broadcast("game" + this.sid, "zn", this.map.zone.scale);
          for (var x = 0; x < this.players.list.length; ++x) {
            tmpObj2 = this.players.list[x];
            if (tmpObj2.active && tmpObj2.team != "inf" && this.map.zone.isOutside(tmpObj2)) {
              if (this.players.changeHealth(tmpObj2, null, 10)) {
                this.players.kill(tmpObj2, null, {});
              }
            }
          }
        }
      } else {
        this.map.zone.animate(delta);
      }
    }

    // PROJECTILES:
    this.projectiles.update(delta * this.config.deltaMlt);

    // UPDATE PARTICLES:
    if (PARTICLES) {
      PARTICLES.update(delta * this.config.deltaMlt, player);
    }

    // RENDER:
    if (RENDER) {
      RENDER.render(delta * this.config.deltaMlt);
    }
  };
};

/* WEBPACK VAR INJECTION */